module.exports = __webpack_public_path__ + "media/images/emblems/Blasonvalderuz-002e7d6aec01ef9f4bee72b0c8aaad2f.png";